import styled from "styled-components";

export const CheckboxWrapper = styled.div`
  display: flex;
  align-content: center;
`;

export const StyledLabel = styled.label`
  font-family: ${({ theme }) => theme.default.fontFamily.secondaryFont};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
  a {
    color: ${({ theme }) => theme.default.color.primary};
  }
`;
